import { pushToPdtEvent } from "./push";
import { PdtLogParams } from "./types";
import { getMergedPdtEvent } from "./utils";

export const log = (params: PdtLogParams): void => {
  const eventPayload = getMergedPdtEvent(params);
  pushToPdtEvent(eventPayload);
};
